import { cn } from "@/lib/utils";

/** Pill tabs in the app's own teal/cream language.
 *
 *  Scrolls sideways rather than wrapping or overflowing on a narrow phone, and every pill clears a
 *  44px tap target. `size="sm"` is the secondary row (the week selector) sitting under a primary one. */
export const TabRow = ({ tabs, active, onChange, size = "md", testId, label }) => (
  <div
    role="tablist"
    aria-label={label}
    data-testid={testId}
    className="-mx-5 flex snap-x gap-2.5 overflow-x-auto px-5 pb-1 [scrollbar-width:none] sm:mx-0 sm:flex-wrap sm:px-0 sm:overflow-visible [&::-webkit-scrollbar]:hidden"
  >
    {tabs.map((tab) => {
      const on = tab.id === active;
      return (
        <button
          key={tab.id}
          role="tab"
          aria-selected={on}
          data-testid={tab.testId}
          onClick={() => onChange(tab.id)}
          className={cn(
            "ps-tap shrink-0 snap-start whitespace-nowrap rounded-full font-semibold transition-all duration-200",
            size === "md"
              ? "min-h-[48px] px-6 text-[15px]"
              : "min-h-[44px] px-5 text-[14px]",
            on
              ? "bg-brand-teal text-white shadow-[0_6px_18px_-8px_rgba(17,60,55,0.55)]"
              : "bg-brand-teal/[0.06] text-brand-teal hover:bg-brand-teal/[0.12]"
          )}
        >
          {tab.label}
        </button>
      );
    })}
  </div>
);
